import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Paper, Typography, Box, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';
import { workshopDomain } from '../util/domain';

const ThankYou = () => {
    const { registrationHashId } = useParams();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchEventDetails = async () => {
            setLoading(true);
            setError('');
            try {
                const regRes = await axios.get(`${workshopDomain}/api/registration/${registrationHashId}`);
                if (regRes.data.success && regRes.data.registration) {
                    const eventHashId = regRes.data.registration.event_hash_id;
                    const eventRes = await axios.get(`${workshopDomain}/api/events/${eventHashId}`);
                    if (eventRes.data.success && eventRes.data.event) {
                        setEvent(eventRes.data.event);
                    } else {
                        setError('Event details not found');
                    }
                } else {
                    setError('Registration not found');
                }
            } catch (err) {
                setError('Failed to fetch event details');
            } finally {
                setLoading(false);
            }
        };
        fetchEventDetails();
    }, [registrationHashId]);

    if (loading) {
        return (
            <Container maxWidth="sm">
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            </Container>
        );
    }

    if (error) {
        return (
            <Container maxWidth="sm">
                <Alert severity="error" sx={{ mt: 4 }}>{error}</Alert>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm">
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                <img src="https://office.vectorindia.org/logo-vector.svg" alt="Vector India Logo" style={{ height: '120px', width: 'auto' }} />
            </Box>
            <Paper elevation={3} sx={{ p: 4, mt: 2 }}>
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Thank You for Registering!
                </Typography>
                <Typography variant="body1" align="center" sx={{ mb: 3 }}>
                    Your registration is successful. Here are your event details:
                </Typography>
                <Box sx={{ my: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
                    <Typography variant="h6" color="primary">
                        {event.title}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        <strong>Date:</strong> {new Date(event.event_start_date).toLocaleDateString()}<br />
                        <strong>Time:</strong> {new Date(event.event_start_date).toLocaleTimeString()} - {new Date(event.event_end_date).toLocaleTimeString()}
                    </Typography>
                    {event.is_online && event.meeting_link && (
                        <Box sx={{ mt: 2 }}>
                            <Typography variant="body2">
                                <strong>Meeting Link:</strong> <a href={event.meeting_link} target="_blank" rel="noopener noreferrer">{event.meeting_link}</a>
                            </Typography>
                            {event.meeting_password && (
                                <Typography variant="body2">
                                    <strong>Meeting Password:</strong> {event.meeting_password}
                                </Typography>
                            )}
                        </Box>
                    )}
                    {!event.is_online && event.venue && (
                        <Typography variant="body2" sx={{ mt: 2 }}>
                            <strong>Venue:</strong> {event.venue}
                        </Typography>
                    )}
                </Box>
            </Paper>
        </Container>
    );
};

export default ThankYou; 